import request from '@/utils/request'

// ==================== 交班记录 ====================

/**
 * 获取交班汇总数据
 * @param {Object} params - 查询参数 { beginTime, endTime }
 */
export function getShiftSummary(params) {
  return request({
    url: '/retail/shift/summary',
    method: 'get',
    params: params
  })
}

/**
 * 分页查询交班记录列表
 * @param {Object} params - 查询参数
 */
export function listShiftRecords(params) {
  return request({
    url: '/retail/shift/page',
    method: 'get',
    params: params
  })
}

/**
 * 获取交班记录详情
 * @param {Number} shiftId - 交班记录ID
 */
export function getShiftDetail(shiftId) {
  return request({
    url: '/retail/shift/detail',
    method: 'get',
    params: { shiftId }
  })
}

/**
 * 创建交班记录
 * @param {Object} data - 交班数据
 */
export function createShiftRecord(data) {
  return request({
    url: '/retail/shift/create',
    method: 'post',
    data: data
  })
}

/**
 * 根据日期范围获取收银统计（用于交班汇总计算）
 * @param {Object} params - 查询参数 { beginTime, endTime }
 */
export function getCashierStatisticsByDateRange(params) {
  return request({
    url: '/retail/cashier/statistics',
    method: 'get',
    params: params
  })
}
